<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智慧农业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          橡诺科技智慧农业云平台以互联网+农业的新型模式，改变传统产业。以互联网为入口、分别从流通渠道，生产模式，营销模式的三个重要环节，为传统农业带来生产与市场与生产资源充分对接的机会。依托物联网和农业云服务平台丰富的云端应用，打通农业产业链上的信息通道，让农与非农形成一二三产协同发展。<br>
          在数据为主角的今天，农业作为热点行业更是离不开大数据的支持，通过大数据展现技术，GIS技术，将大量的历史数据、统计数据、物联网设备实时数据和互联网产生的数据有效的整合起来，有效的为农业生产、市场流通及政府监管决策提供精准的数据支持。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          我们将基于云平台上的一系列核心产品，根据地方特色和区域基础农业的发展规划，量身制定适合地方产业特色和产业发展规划的全方位解决方案。<br>
          在农业自身产业升级方面，全产业链农产品溯源，特色农产品电商，智能种植管理等等应用服务平台，将会打通产业信息链，形成规模化，集约化的农业生产，用工业的方式展现现代农业。<br>
          在农村社会管理方面，乡村之窗，政务管理，农村金融服务会把涉及农业生产的方方面面资源进行整合，创造易于交互易于管理的信息平台。<br>
          在服务农民方面，惠农APP，农资通，等等随时随地的为农民提供生活和劳作方面的信息服务。
          <div class="img"><img src="@/assets/img/solution/15/1.png"></div>
        </div>
        <div class="title-sub">方案特点</div>
        <div class="text">
          智慧农业云平台具有三大创新点：<br>
          第一、 技术领先，服务灵活<br>
          采用了最先进的云架构模式，快速的部署和模块化的云端应用服务，使得平台可以在短时间内，为用户提供高性能的定制化服务。用户可以以灵活的方式获得所需的服务，最大限度的避免了系统重构所造成的资源浪费，同时也可以将信息共享范围最大化。<br>
          第二、 应用丰富，服务全面<br>
          平台上丰富的应用服务主要从产业信息化服务，农村社会信息化管理，农民生活服务三个方面，用信息化影响和改变农业的生产经营方式、农村的服务管理方式、农民的生活劳作方式。<br>
          第三、 大数据服务<br>
          基于地理信息系统，通过物联设备，移动设备的多种手段进行标准化的数据采集，经过分析计算后形成可以指导和服务于产业的数据模型，并以最直观的可视化的方式呈现。
        </div>
        <div class="title-sub">服务能力</div>
        <div class="text">
          2015年与中国农业大数据共同成立了农业互联网大数据研究中心，为农业大数据的服务提供了强力的学术支持。<br>
          2015年成立了中国渔业物联网技术创新联盟，联盟包含水产技术推广总站、科研院校、龙头企业以及信息化企业构成了渔业中的全产业生态型联盟全方位为产业提供服务。
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          通过信息化的改造，农业将成为规模化，标准化生产的工业化生产模式，农产品的质量与附加价值都将得到保证与提高。产业链信息通道的打通，更是可以协同生产加工流通等各个环节，让生产效率大幅度提高，整个产业链上的每个环节都获取到合理的价值。宏观管理与调控也可以做到量化精准管理，形成产业链的良性循环。<br>
          同时，橡诺科技的农业大数据，将为农业生产，农村社会管理，提供更有价值的服务，种植生产模型，市场波动分析，灾害预警，信用评估等等这些建立在大数据分析基础上的结果，可以直接的作用于农业产业的健康发展，加快实现现代农业建设。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>